

export default function DocumentValidator(value){

    const data = value.replace(/[.\-/]/g, '').toUpperCase();

    // Converte cada caractere (dígito ou letra) no valor usado pela RFB para o
    // CNPJ alfanumérico: código ASCII - 48. Dígitos 0-9 mantêm seu valor (0-9);
    // letras A-Z (maiúsculas) viram valores 17-42.
    function charValue(char) {
        return char.charCodeAt(0) - 48;
    }

    function validarCNPJ(cnpj) {

        if (cnpj === '') return false;

        if (cnpj.length !== 14) return false;

        // Os 2 dígitos verificadores são sempre numéricos
        if (!/^\d{2}$/.test(cnpj.slice(12))) return false;

        // As 12 primeiras posições (raiz + ordem) aceitam letras maiúsculas e números
        if (!/^[A-Z0-9]{12}$/.test(cnpj.slice(0, 12))) return false;

        // Elimina CNPJs numéricos inválidos conhecidos (sequências repetidas)
        if (/^(\d)\1{13}$/.test(cnpj)) return false;

        // Valida DVs
        let tamanho = cnpj.length - 2;
        let numeros = cnpj.substring(0, tamanho);
        const digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
            soma += charValue(numeros.charAt(tamanho - i)) * pos--;
            if (pos < 2) pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != digitos.charAt(0)) return false;

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += charValue(numeros.charAt(tamanho - i)) * pos--;
            if (pos < 2) pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != digitos.charAt(1)) return false;

        return true;
    }
    
    function validarCPF(cpf) {
    
        if (cpf === '') return false;
    

        if (
            cpf.length !== 11 ||
            cpf === '00000000000' ||
            cpf === '11111111111' ||
            cpf === '22222222222' ||
            cpf === '33333333333' ||
            cpf === '44444444444' ||
            cpf === '55555555555' ||
            cpf === '66666666666' ||
            cpf === '77777777777' ||
            cpf === '88888888888' ||
            cpf === '99999999999'
        )
            return false;
    
        // Valida 1o dígito
        let add = 0;
        for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
        let rev = 11 - (add % 11);
        if (rev === 10 || rev === 11) rev = 0;
        if (rev !== parseInt(cpf.charAt(9))) return false;
    
        // Valida 2o dígito
        add = 0;
        for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
        rev = 11 - (add % 11);
        if (rev === 10 || rev === 11) rev = 0;
        if (rev !== parseInt(cpf.charAt(10))) return false;
    
        return true;
    }
    
    
    const response = data.length <= 11 ? validarCPF(data) : validarCNPJ(data);

    return response;
    

}